var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"lg"}},[_c('div',{staticClass:"tabla sombra"},[_c('list-regions')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }